import React, { useEffect, useState, useCallback } from 'react';
import AlbumForm from '../AlbumForm/Container'

import { Uploader, UploadField } from '@navjobs/upload'
import {serverUrl} from '../../utils/restUtils'
import {Link} from 'react-router-dom'
import ReactTooltip from 'react-tooltip'
import Carousel, { Modal, ModalGateway } from "react-images";
import '../Albums/albums.css'


export default  ({album, authenticated, loadAlbum, removePhoto, clearAlbum, match: {params: {id}}}) =>  {  
    
    useEffect(() => {
	loadAlbum(id)
	return function cleanup() {
	    console.log('clearing')
	    clearAlbum()
	}
    }, []);



    const [currentImage, setCurrentImage] = useState(0);
    const [viewerIsOpen, setViewerIsOpen] = useState(false);

    const openLightbox = useCallback((event, { photo, index }) => {
	setCurrentImage(index);
	setViewerIsOpen(true);
    }, []);

    const closeLightbox = () => {
	setCurrentImage(0);
	setViewerIsOpen(false);
    };

    const photos =  album.photos ? album.photos.map(p => ({...p, width: 1,height: 1})) : []
   
    return (
	<div>
	    <h1>{album.name}</h1>


	   
	    
		 <Uploader
		     request={{
			 fileName: 'file',
			 url: serverUrl()+'/albums/'+album.id+'/photos',
			 method: 'POST',
			 withCredentials: true
		     }}
		     onComplete={({ response, status }) => {
			 loadAlbum(id)
		     }}
		     uploadOnSelection={true}
		 >
		     {({ onFiles, progress, complete }) => (
			 <div>	
			     <UploadField onFiles={files => {
				 if(Array.from(files).map(f => f.size>100*1024*1024 ).filter(x => x ).length === 0){
				     Array.from(files).forEach(element => onFiles([element]))
				 }
				 else
				     alert('preveč velik file, max 100MB')
			     } }  uploadProps={{ accept: '.png,.jpg,.jpeg,.svg,.gif', multiple: true}}>
				 
				 { authenticated ? <button className="btn btn-brown btn-big full-width">
				     <i className="fa fa-camera"></i> Dodaj sliko
				 </button>
				   : null}
				 
			     </UploadField>
			     
			     
			     {!complete && progress  ?
			      <div className="progressBar">
				  <div style={{width: progress+'%'}}></div>
			      </div>
			     : null}

			 </div>
		     )}
		 </Uploader>

		 <div className="albums">
		     {photos.map((photo, index) => <div key={photo.id} className="albumLink">
			 <div className="adminSection">
			     {authenticated ? <button style={{float: 'right'}} data-tip="Zbriši"  className="btn" onClick={()=>removePhoto(album.id, photo.id)}><i className="fa fa-remove"></i></button> : null}	
			     <div style={{clear: 'both'}}></div>
			 </div>
			 <div onClick={() => {
			     setCurrentImage(index);
			     setViewerIsOpen(true);
			 } } style={{cursor: 'pointer'}}>
			     <img src={photo.url} />
			 </div>
		     </div>)}
		 </div> 

	    
	    
	    <ModalGateway>
		{viewerIsOpen ? (
		    <Modal onClose={closeLightbox}>
			<Carousel
			currentIndex={currentImage}
			views={photos.map(x => ({
			    
			    src: x.url,
			    srcset: x.url,
			    caption: ''
			}))}
			/>
		    </Modal>
		) : null}
	    </ModalGateway>



	    
	    
	    
	</div>
    );
    
}



// WEBPACK FOOTER //
// ./src/components/Album/index.jsx